const types = {
  CORRUPT_SEGMENTATION_TREE: 'corruptSegmentationTree',
  DEFAULT: 'default',
};

const modals = {
  [types.DEFAULT]: {
    type: types.DEFAULT,
    title: 'Oops, something went wrong!',
    message: 'Sorry about that. Please refresh the page to continue.',
    buttonText: 'Refresh',
    onButtonClick: () => window.location.reload(),
  },
  [types.CORRUPT_SEGMENTATION_TREE]: {
    type: types.CORRUPT_SEGMENTATION_TREE,
    title: 'Oops, something went wrong!',
    message:
      'An error occurred. The last split operation is being reverted. Please move the slider to a different height and try again.',
    buttonText: 'Ok',
    onButtonClick: null,
  },
};

export default {
  types,
  modals,
};
